module.exports = __webpack_public_path__ + "static/img/promociones.ffb14806.jpg";